import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { CallOfferRoutingModule } from './call-offer-routing.module';
import { CallOfferSuggestionComponent } from './components/call-offer-suggestion/call-offer-suggestion.component';
import { CallOfferListComponent } from './components/call-offer-list/call-offer-list.component';
import { ArchivedCallOfferComponent } from './components/archived-call-offer/archived-call-offer.component';
import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DetailsOfferComponent } from './components/details-offer/details-offer.component';
import { CandidatureCallOfferComponent } from './components/candidature-call-offer/candidature-call-offer.component';
import { DetailcandidaturecallofferComponent } from './components/detailcandidaturecalloffer/detailcandidaturecalloffer.component';
import { DetailsuggestionComponent } from './components/detailsuggestion/detailsuggestion/detailsuggestion.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ContactcallofferComponent } from './components/contactcalloffer/contactcalloffer.component';
import { QuillModule } from 'ngx-quill';
import { FieldErrorModule } from './../../shared/components/shared-field-error/field-error.module';
import { DossierCandidatureComponent } from './components/dossier-candidature/dossier-candidature.component';
import { CalendarModule } from 'primeng/calendar';
import localeFr from '@angular/common/locales/fr';


@NgModule({
  declarations: [
    CallOfferListComponent,
    CallOfferSuggestionComponent,
    ArchivedCallOfferComponent,
    DetailsOfferComponent,
    CandidatureCallOfferComponent,
    DetailcandidaturecallofferComponent,
    DetailsuggestionComponent,
    ContactcallofferComponent,
    DossierCandidatureComponent
  ],
  imports: [
    CommonModule,
    CallOfferRoutingModule,
    PaginationModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxSpinnerModule,
    CalendarModule,
    FieldErrorModule,
    QuillModule.forRoot({
      modules: {
        syntax: true,
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          ['blockquote', 'code-block'],

          [{ header: 1 }, { header: 2 }], // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
          [{ direction: 'rtl' }], // text direction

          [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],

          ['clean'], // remove formatting button
        ],
      },
    }),
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'fr-FR' }]

})
export class CallOfferModule {
  constructor() {
    registerLocaleData(localeFr);
  }
}
